export default __webpack_public_path__ + "static/media/Museo300-Regular.e7621b0f.ttf";